// https://ads.tiktok.com/help/article?aid=10028
// Deduplication: https://ads.tiktok.com/marketing_api/docs?id=1723170195197953
// TODO check all events and add more if there are any

/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load TikTok Ads event listeners
 *
 * Source: https://ads.tiktok.com/help/article/supported-standard-events
 * */

// Pixel load event listener
jQuery(document).on("pmw:load-pixels", () => {

	if (wpmDataLayer?.pixels?.tiktok?.pixel_id && !wpmDataLayer?.pixels?.tiktok?.loaded) {
		if (wpm.consent.canPixelBeFired("marketing", "TikTok")) wpm.loadTikTokPixel()
	}
})

const handleTikTokEvent = (eventName, event, payload) => {
	try {
		if (wpm.canNotFireTikTokEvent()) return

		// Get TikTok data from unified payload
		const tiktokData = payload.pixels?.tiktok;
		if (!tiktokData) {
			pmw.console.warn(`TikTok event data not found in payload for ${eventName}`);
			return;
		}

		ttq.track(
			tiktokData.event,
			tiktokData.properties,
			{event_id: tiktokData.event_id},
		)

		pmw.console.log(`TikTok Pixel: ${tiktokData.event} event sent`, tiktokData)

	} catch (e) {
		console.error(e)
	}
}

const tikTokEvents = [
	"pmw:s2s:view-item",
	"pmw:s2s:add-to-cart",
	"pmw:s2s:add-to-wishlist",
	"pmw:s2s:search",
	"pmw:s2s:begin-checkout",
	"pmw:s2s:add-payment-info",
	"pmw:s2s:place-order",
	"pmw:s2s:purchase", // Browser pixel fires here, server-side handled via PHP Events API
]

tikTokEvents.forEach(eventName => {
	jQuery(document).on(eventName, handleTikTokEvent.bind(null, eventName))
})
